import { Dispatch, Action } from 'redux';
import { postLogout } from 'services/ApiCustomerPageService';
import { getPage } from 'components/Pagelayout/actions';
import { createHref } from 'components/Shared/server';
import { CustomerOrder } from 'models/CustomerOrder';

export const CUSTOMERPAGE_LOGOUT = 'CUSTOMERPAGE_LOGOUT';
export const CUSTOMERPAGE_RETURN = 'CUSTOMERPAGE_RETURN';
export const CUSTOMERPAGE_RETURN_COMPLETE = 'CUSTOMERPAGE_RETURN_COMPLETE';
export const CUSTOMERPAGE_PRICE_MATCH_COMPLETE = 'CUSTOMERPAGE_PRICE_MATCH_COMPLETE';
export const CUSTOMERPAGE_ORDERHISTORY = 'CUSTOMERPAGE_ORDERHISTORY';
export const CUSTOMERPAGE_DELIVERIES_COMPLETE = 'CUSTOMERPAGE_DELIVERIES_COMPLETE';
export const CUSTOMERPAGE_CHANGE_COMPLETE = 'CUSTOMERPAGE_CHANGE_COMPLETE';
export const CUSTOMERPAGE_CLAIMS_COMPLETE = 'CUSTOMERPAGE_CLAIMS_COMPLETE';
export const CUSTOMERPAGE_SHIPPING_DAMAGE_COMPLETE = 'CUSTOMERPAGE_SHIPPING_DAMAGE_COMPLETE';
export interface ReturnAction extends Action {
  order: CustomerOrder;
}

export const loggedout = () => ({
  type: CUSTOMERPAGE_LOGOUT
});

export const logout = (url: string) => {
  return (dispatch: Dispatch) => {
    void postLogout().then(_response => {
      void dispatch(getPage(createHref(url)));
    });
  };
};

export const returns = (order: CustomerOrder) => {
  return {
    type: CUSTOMERPAGE_RETURN,
    order
  };
};

export const returnsComplete = () => {
  return {
    type: CUSTOMERPAGE_RETURN_COMPLETE
  };
};

export const priceMatchComplete = () => {
  return {
    type: CUSTOMERPAGE_PRICE_MATCH_COMPLETE
  };
};

export const deliveriesComplete = () => {
  return {
    type: CUSTOMERPAGE_DELIVERIES_COMPLETE
  };
};

export const changeComplete = () => {
  return {
    type: CUSTOMERPAGE_CHANGE_COMPLETE
  };
};

export const claimsComplete = () => {
  return {
    type: CUSTOMERPAGE_CLAIMS_COMPLETE
  };
};

export const shippingDamageComplete = () => {
  return {
    type: CUSTOMERPAGE_SHIPPING_DAMAGE_COMPLETE
  };
};

export const orderlist = () => ({
  type: CUSTOMERPAGE_ORDERHISTORY
});
